<div class="main">
  <label>
    <textarea
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="validarValor()"
       [ngClass]="{'has-value': control.value, 'focused-with-value': isFocused && control.value}"
      [style.border-color]="control.value ? '#008A2F' : error ? '#ff0000' : '#000'"
      class="input__field"
      [formControl]="control"
      [readOnly]="readonly"
      [style.border]="control.value ? '0.5px solid #008A2F' : ''"
      [rows]="linhas">
    </textarea>
    <span class="input__label" [style.color]="control.value ? '#008A2F' : error ? '#ff0000' : '#000'">{{ placeholder }}</span>
  </label>
</div>
@if(error) {

  <div class="error">
    <h6>Campo Obrigatório</h6>
    <span class="material-symbols-outlined">info</span>
  </div>
}
